module.exports = __webpack_public_path__ + "img/message_active1.45499ab4.svg";